<template>
  <div class="animated fadeIn returkirimanfrm">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <button class="btn btn-success mr-1" @click.stop="save()" :disabled="!(frmdata.customer_id)"> <i class="fa fa-pencil"></i> Save & Lanjut Edit</button>
          <button class="btn btn-success mr-1" @click.stop="saveclose()" :disabled="!(frmdata.customer_id)"> <i class="fa fa-save"></i> Save & Close</button>
          <b-button class="btn btn-danger mr-1" @click="close()"> <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
        <b-row class="justify-content-center">
          <b-col lg="11" xl="8">

          <b-row>            
            <b-col lg="5">
              <b-input-group>
                  <b-input-group-prepend><label>Nomor Retur</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.no_return" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING" ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                  <b-input-group-prepend><label style="width:188px !important; text-align:right;">Tanggal Retur</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.tglretur" type="date" @change="tanggalBerubah" :disabled="isEdit"></b-form-input>                                        
              </b-input-group>
            </b-col>
          </b-row>            

            <b-input-group>
              <b-input-group-prepend><label>Agen / Langganan</label></b-input-group-prepend>
                <b-form-input v-model="frmdata.CustCode" placeholder="Kode" :state="!$v.frmdata.customer_id.$error" readonly></b-form-input>
              <b-form-input
                readonly
                v-model="frmdata.CustName"
                @click.native="lkuKoranAgenShow=true"
                placeholder="Pilih Agent" style="width:45% !important; margin-left:3px;"
                :state="!$v.frmdata.customer_id.$error"
              ></b-form-input>
              <b-input-group-append v-show="!isEdit">
                <b-btn
                  text="Button"
                  id="btnKoranAgen"
                  @click="lkuKoranAgenShow=true"
                  :disabled="isEdit"
                >
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
              <b-form-invalid-feedback id="input-1-live-feedback">Klik untuk melakukan pencarian.</b-form-invalid-feedback>
            </b-input-group>
          <b-row>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Maksimal Hari Retur</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmdata.toleransiRetur" disabled></b-form-input>
                 <b-input-group-append><span class="input-group-text">Hari</span></b-input-group-append>
                <!-- <b-input-group-append>
                  <span class="p-2">Maksimal Jml Retur</span>
                </b-input-group-append>
                <b-input-group-append><span class="input-group-text">{{frmdata.max_retur}} %</span></b-input-group-append> -->
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend><label style="width:188px !important; text-align:right;">Tgl. Pengambilan Fisik Koran</label></b-input-group-prepend>
                <b-form-input v-model="frmdata.pickupdate" type="date" style="width:50% !important" ></b-form-input>                                        
              </b-input-group>
            </b-col>
          </b-row>            
          <div class="report-wraper mt-2">
            <table style="width: 100%;">
              <thead>
                <tr class="text-center">
                  <th style="max-width:20px;padding:0; text-align:center;">No.</th>
                  <th style="max-width:200px;text-align:center;">Tgl/Edisi Koran</th>
                  <th style="max-width:80px;padding:0; text-align:center;">Total Kiriman (Berbayar)</th>
                  <th style="max-width:80px;padding:0; text-align:center;">Jlm. Konsinyasi (Bisa RETUR)</th>
                  <th style="max-width:80px;padding:0; text-align:center;">Total Retur Sebelumnya</th>
                  <th style="max-width:80px;padding:0; text-align:center;">Batas Retur</th>
                  <th style="max-width:80px;padding:0; text-align:center;">Retur Kali ini</th>
                  <th style="min-width:200px;">Uraian</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row,index) in dataItems"
                  :key="row.kirimanKey"
                >
                  <td style="padding:0; text-align:center;" class="disabled">{{index+1}}</td>
                  <td style="text-align:center;" class="disabled">{{row.tanggal | ambilNamaHari}}, {{row.tanggal | moment("DD-MMM-YY")}}</td>
                  <td style="text-align:right;" :class="[model[index].isChange==0 ? 'disabled' : 'edited']">{{row.totpaid}}</td>
                  <td style="text-align:center;" class="disabled">{{row.totKonsi}}</td>
                  <td style="text-align:right;" :class="[model[index].invalidKonsi ?  'expired':'disabled']">{{row.retkonsi}}</td>
                  <td style="text-align:center;" class="disabled">{{row.maxKonsi}}</td>
                  <td style="text-align:right;padding:0;">
                    <b-form-input
                      v-model="model[index].konsi"
                      :key="index"
                      type="number"
                      :min="0"
                      :max="model[index].maxKonsi"
                      style="text-align:right;"
                      @change.native="updateKonsi(index)"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      v-if="model[index].invalidKonsi"
                      id="input-1-live-feedback"
                      style="font-size:90%;display:unset;"
                    >Melebihi total konsinyasi.</b-form-invalid-feedback>
                  </td>
                  <td style="padding:0;">
                    <b-form-input
                      v-model="model[index].uraian"
                      :key="index"
                      type="text"
                      placeholder="Alasan retur" style="font-size:smaller !important;"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback">Harap isi uraian.</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="text-right">
                    <strong>TOTAL</strong>
                  </td>
                  <td class="text-right subtotal">
                    <span class="mr-1">{{ttlKonsiRetur}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          </b-col>
        </b-row>

      <b-row class="justify-content-center mt-2">
        <button class="btn btn-success mr-1" @click.stop="save()" :disabled="(!(frmdata.customer_id))">
           Save & Lanjut Edit
        </button>
        <button class="btn btn-success mr-1" @click.stop="saveclose()" :disabled="(!(frmdata.customer_id))">
           Save & Close
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Close
        </b-button>
      </b-row>
    </b-card>

    <!-- <b-modal v-model="showSaveConfirm" title="Simpan Perubahan?" :centered="true" @ok="save">
      <p class="mb-1">Data Akan Disimpan</p>
      <p class="font-weight-bold m-0 text-danger">Apakah anda yakin?</p>
    </b-modal>-->

    <b-modal
      v-model="lkuKoranAgenShow"
      size="lg"
      :hide-footer="true"
      title="List of Agent"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranAgen" bill2group="'0'" ></lku-koran-cust>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
<style lang="scss">
  .returkirimanfrm {
    .input-group {
      padding-bottom: 2px;
      .input-group-prepend {
        label {
          padding-top: 5px;
          padding-right: 5px;
          width: 130px;
        }
      }
    }
  table {
      td.disabled {
        background: #e4e7ea;
      }
    
      td.expired {
        background:#ff7070;
      }

      td.edited {
        background: #9effd5;
      }
      
      td.subtotal {
          border-top: 2px solid #000 !important;
      }
  }

  }
</style>

<script>
import Loading from "vue-loading-overlay";
import moment from "moment";
import vNumber from "vue-numeric";
// import crud from "../../apis/crud";
// import customer from "../../apis/customer";
import koran_kiriman_retur from "../../apis/koran_kiriman_retur";
import lkuKoranKiriman from "../lookup/lkuKoranKiriman";
import lkuKoranCust from "../lookup/lkuKoranPolaHarga";

import { validationMixin } from "vuelidate";
import {
  required,
  minValue,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading, vNumber, lkuKoranKiriman, lkuKoranCust },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      customer_id: { required },
      pickupdate: { required },
      tglretur: { required },
      uraian: {}
    }
  },
  data() {
    return {
      isLoading: false,
      lkuKoranAgenShow: false,
      showSaveConfirm: false,
      saveEnabled: true,
      saveAndClose: false,
      // tglaktif: moment().subtract(5,'days').format('YYYY-MM-DD'),
      tglaktif: this.$store.state.user.tglkoran,
      uanguser: this.$store.state.user.matauang,
      model: [],
      modelReturnSave: [],
      kiriman: {},
      frmdata: {
        returhdrKey: null,
        customer_id: '',
        pickupdate: moment(new Date()).format("YYYY-MM-DD"),
        tglretur: moment(new Date()).format("YYYY-MM-DD"),
        no_return: null
      },
      dataItems: [],
      returdetail:[],
      ttlKonsi: 0,
      ttlsumReturKonsi: 0,
      ttlKonsiRetur: 0,
      isEdit: false,
      pickupdate: new Date(),
      tglretur: new Date(),
    };
  },
  filters: {
    ambilNamaHari(tanggal) {
      const namesDay = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ];
      const day_ = namesDay[moment(tanggal).day()];
      return day_;
    }
  },  
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function() {
    if (this.$route.params.returhdrKey) {
      this.isLoading = true;
      this.canProses = false;
      toastr.info("Harap tunggu, sedang memuat infromasi.");
      try {
        this.frmdata = JSON.parse(JSON.stringify(this.$route.params));
        this.frmdata.custinfo =
          this.$route.params.CustCode + " | " + this.$route.params.CustName;
        this.frmdata.CustCode =this.$route.params.CustCode ;
        this.frmdata.CustName = this.$route.params.CustName;
        this.isEdit = true;
        this.getData();
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
      }
    }
  },
  methods: {
    onSelectKoranAgen(_selected) {
      if (_selected && _selected.customer_id) {
        this.isLoading = true;
        this.frmdata.custinfo = _selected.CustCode + " | " + _selected.CustName;
        this.frmdata.CustCode = _selected.CustCode ;
        this.frmdata.CustName = _selected.CustName ;
        this.frmdata.customer_id = _selected.customer_id;
        this.lkuKoranAgenShow = false;
        this.getData();
      }
    },
    updateKonsi(index) {
      setTimeout(() => {
        const valKonsi = parseInt(this.model[index].konsi);
        if (valKonsi !== this.dataItems[index].konsi) {
          this.model[index].isChange = 1; // marked if get changed
        } else {
          this.model[index].isChange = 0;
        }
        if (valKonsi > this.model[index].maxKonsi) {
            this.model[index].invalidKonsi = true;
        } else {
            this.model[index].invalidKonsi = false;
        }
        this.calcProses();
        
      }, 100);
    },
    calcProses() {
      this.ttlKonsiRetur = this.model.reduce((a, b) => a + ((b.invalidKonsi ==false) ? parseInt(b.konsi):0) , 0);
      // this.ttlKonsiRetur = this.model.reduce((a, b) => a + (((b.invalidKonsi ==false) && (b.validUraian ==true)) ? b.konsi : 0), 0);
    },
    saveclose(){
      this.saveAndClose=true;
      this.save();
    },
    async save() {
      this.isLoading=true;
      if (this.ttlKonsiRetur) {
        if (this.invalidFrmdata) {
          const invalidobj={};
          for (var key in this.$v.frmdata) {
            if (this.$v.frmdata[key].$anyError) {
              if (this.$v.frmdata[key].$anyError==true) invalidobj[key] = this.$v.frmdata[key];
            }
          }        
          console.log('validation frmdata: ', this.$v.frmdata);
          console.log('validation field: ', invalidobj);
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
          this.isLoading=false;        
        } else if (moment(this.model.tglretur).format("YYYY-MM-DD")<this.tglaktif) {
                toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);
                this.isLoading=false;        
        } else {
          try {
            // let canSave = true;
            toastr.info('Hanya data retur yg VALID yg akan disimpan', this.$route.meta.label, 10000);
            const dataRetur = this.model.reduce((newArr, item, index) => {
              if (((item.konsi || 0) != 0) && (item.invalidKonsi==false)) {
                  newArr.push(item);
              }
              return newArr;
            }, []);
            // console.log('dataRetur: ', dataRetur);
            if (dataRetur.length>0) {
            // if (canSave) {
              const row={header:{}};
              this.frmdata.tglretur = (this.frmdata.tglretur) ? moment(this.frmdata.tglretur).format('YYYY-MM-DD') : '';
              for (var key in this.frmdata) {
                  row.header[key] = this.frmdata[key];
              }
              row.header.pickupdate = (this.frmdata.pickupdate) ? moment(this.frmdata.pickupdate).format('YYYY-MM-DD') : '';
              row.header.totreturn=this.ttlKonsiRetur;
              row.line=dataRetur;

              const hasil= await koran_kiriman_retur.save(row);
              toastr.success(`Save successfully, Trx.Number ${hasil.no_return}`, this.$route.meta.label,10000);
              this.isLoading=false;
              if (this.saveAndClose==true){
                  router.push({ name: "koran.returkiriman" });
              }
              this.frmdata.returhdrKey= hasil.returhdrKey;
              this.frmdata.no_return= hasil.no_return;
              this.isEdit=true;
              this.model=[];
              this.getData();

            } else {
              this.isLoading=false;
              toastr.error('tidak ada data retur yg VALID untuk disimpan', this.$route.meta.label, 10000);
            }
          } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
          }
        }
      } else {
        this.isLoading=false;
        toastr.error('tidak ada data retur yg VALID untuk disimpan', this.$route.meta.label, 10000);
      } 

    },
    async tanggalBerubah(){
      this.getData();
    },
    siapkanModel(kiriman, kirimansubagen){
        this.frmdata.max_retur= (kiriman[0]) ? kiriman[0].max_retur : 0;
        kiriman.forEach(async (el, idx) => {
          kiriman[idx].returKey='';
          kiriman[idx].uraian='';
          kiriman[idx].validUraian=true;
          kiriman[idx].isChange= 0;
          kiriman[idx].totKonsi= el.konsi;

          const findSubagen = kirimansubagen.find(x => x.tanggal === el.tanggal);
          if (findSubagen) {
            kiriman[idx].totKonsi += findSubagen.konsi;
            kiriman[idx].totpaid += findSubagen.eceran;
            kiriman[idx].langganan += findSubagen.langganan;
            kiriman[idx].eceran += findSubagen.eceran;
            findSubagen.terpakai=1;
          }
          kiriman[idx].tanggal = moment(el.tanggal).format("YYYY-MM-DD");
          kiriman[idx].konsi= 0;
        });

        const belumTerpakai = kirimansubagen.filter(s => !(s.terpakai));
        belumTerpakai.forEach(async (el, idx) => {
          const objKiriman={
          kirimanKey: el.kirimanKey,
          nofaktur: el.nofaktur,
          returKey:'',
          uraian:'',
          validUraian:true,
          isChange: 0,
          totKonsi: el.konsi,
          totpaid: el.eceran,
          eceran: el.eceran,
          langganan : el.langganan,
          retkonsi: 0
          };
          objKiriman.tanggal = moment(el.tanggal).format("YYYY-MM-DD");
          objKiriman.konsi= 0;
          kiriman.push(objKiriman);
        });

        kiriman.forEach(async (el, idx) => {
          // totkonsi diambil dari data kiriman saja jangan dihitung ulang disini
          // el.totKonsi = Math.floor(el.eceran * (parseInt(this.frmdata.max_retur || 0)/100));
            const findReturDetail = this.returdetail.find(x => x.kirimanKey === el.kirimanKey);
            if(findReturDetail){
              kiriman[idx].returKey=findReturDetail.returKey;
              kiriman[idx].uraian=findReturDetail.uraian;
              kiriman[idx].konsi= findReturDetail.konsi;
              kiriman[idx].retkonsi = (el.retkonsi || 0) - findReturDetail.konsi;
              kiriman[idx].invalidKonsi = false;
            }
          kiriman[idx].maxKonsi = (el.totKonsi || 0) - (el.retkonsi || 0);
        });
        kiriman.sort(
              function(a, b) {          
                  var dateA = new Date(a.tanggal), dateB = new Date(b.tanggal);                        
                  return dateA - dateB;
              });

        this.dataItems=kiriman;
        this.model=JSON.parse(JSON.stringify(kiriman));
        this.ttlKonsiRetur = this.model.reduce((a, b) => a + ((b.invalidKonsi ==false) ? parseInt(b.konsi):0) , 0);

        this.frmdata.toleransiRetur= (kiriman[0]) ? kiriman[0].toleransiRetur : 31;
    },
    async getData() {
      this.isLoading = true;
      this.dataItems = [];
      // let resp;
      let kiriman;
      let dsReturheader;
      let returheader;
      let returdetail;
      let kirimansubagen;
      if (this.frmdata.returhdrKey) {
        [kiriman,[returheader],returdetail, kirimansubagen] = await koran_kiriman_retur.detail(this.frmdata);
        this.frmdata.returhdrKey= returheader.returhdrKey;
        this.frmdata.no_return = returheader.no_return;
        this.frmdata.tglretur = (returheader.tglretur) ? moment(returheader.tglretur).format('YYYY-MM-DD') : '';
        this.frmdata.pickupdate = (returheader.pickupdate) ? moment(returheader.pickupdate).format('YYYY-MM-DD') : '';
        this.returdetail=returdetail;
        // resp[0].returKonsiEdit = parseInt(resp[0].returkonsi, 10);


      } else {
        // [kiriman] = await koran_kiriman_retur.getKiriman(this.frmdata);
        // this.returdetail=[];
        [kiriman,kirimansubagen, dsReturheader, returdetail] = await koran_kiriman_retur.cekretur(this.frmdata);

        // console.log('kirimansubagen: ',kirimansubagen);
        // if (returheader){
          if (dsReturheader){
            returheader=dsReturheader[0];
            if (returheader) {
                this.isEdit=true;
                const pesan = `Ada Data retur tgl.${moment(this.frmdata.tglretur).format('DD MMM YYYY')} atas Customer: ${this.frmdata.CustName}, Total Retur: ${returheader.totreturn}eks.,                                 
                              \n  Return otomatis akan digabungkan.`
                this.$bvModal.msgBoxOk(pesan);
                    this.frmdata.returhdrKey= returheader.returhdrKey;
                    this.frmdata.no_return = returheader.no_return;
                    this.frmdata.tglretur = (returheader.tglretur) ? moment(returheader.tglretur).format('YYYY-MM-DD') : '';
                    this.frmdata.pickupdate = (returheader.pickupdate) ? moment(returheader.pickupdate).format('YYYY-MM-DD') : '';
                    this.returdetail=returdetail;
                    this.isEdit=true;
            }
          }
        // }
        this.returdetail= returdetail || [];
      }
      this.isLoading = false;
      this.siapkanModel(kiriman,kirimansubagen)      
    },
    async close() {
      const findChange = this.model.find(x => x.isChange==1);
      if (findChange){
          // toastr.warn('Your Change is discharged (not saved)');
          let jawaban = false;
          jawaban = await this.$bvModal.msgBoxConfirm('Data yg anda input/ubah belum disimpan, mau Simpan data dulu?', {
                    title: 'Please Confirm',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Iya',
                    cancelTitle: 'Tidak',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                  });
          if (jawaban == true) {        
            this.saveAndClose=true;    
            this.save();
          }  else {
            router.push({ name: "koran.returkiriman" });
          }   

      } else {
        router.push({ name: "koran.returkiriman" });
      }
      
    }
  }
};
</script>